// cSpell:ignore unmount
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import LeftBar from "../../components/LeftBar";

class LeftBarContainer extends Component {
  static propTypes = {
    // Injected by React-Redux
    userGroup: PropTypes.string,
    userType: PropTypes.string
  };

  render = () => {
    const { userGroup, userType } = this.props;
    return (
      <LeftBar
        isAdmin={"admin" === userGroup}
        isAnyStaff={"hsp" !== userGroup}
        isOther={"LabTechnician" === userType}
      />
    );
  };
}

const mapStateToProps = state => ({
  userGroup: state.auth.user.group,
  userType: state.auth.user.type
});

export default withRouter(connect(mapStateToProps)(LeftBarContainer));
